export const breakPointBig = 1600;
export const breakPoint = 1350;
export const breakPointSmall = 1100;
export const breakPointXS = 700;
